<template>
  <div>
    <el-dialog
      :title="chatrecord.content.title && chatrecord.content.title.length > 25 ? chatrecord.content.title.slice(0, 29) + '...' : chatrecord.content.title + '的聊天记录'"
      :visible.sync="visible"
      append-to-body
      :modal-append-to-body="false"
      :before-close="first"
      width="557px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <!-- 1转发聊天记录 -->
      <ul class="chatrecord-list" v-if="chatrecord && chatrecord.content">
      <p></p>
        <li v-for="(record, index) in chatrecord.content.item" :key="index">
          <div style="color: rgba(0,0,0,0.2500);">
            {{ $moment(Number(record.msgtime + '000')).format('YYYY-MM-DD HH:mm:ss') }}
          </div>
          <!-- 文本 -->
          <div class="text" v-if="record.type === 'ChatRecordText'">
            <span v-if="antistop" v-html="strMark(JSON.parse(record.content).content, antistop)"></span>
            <span v-else-if="associat" v-html="strMarks(JSON.parse(record.content).content, associat)"></span>
            <span v-else>{{JSON.parse(record.content).content}}</span>
          </div>
          <!-- 文件 -->
          <div class="file" v-else-if="record.type === 'ChatRecordFile'" @click="download01(record)">
            <div style="display: flex;">
              <div class="ijdfj">
                <img
                  v-if="record.content.fileext === 'xmind'"
                  src="../assets/images/icon-psd.png"
                  width="40"
                />
                <img
                  v-else-if="record.content.fileext === 'pdf'"
                  src="../assets/images/icon-pdf.png"
                  width="40"
                />
                <img
                  v-else-if="record.content.fileext === 'doc' || record.content.fileext ==='docx'"
                  src="../assets/images/icon-docx.png"
                  width="40"
                />
                <img
                  v-else-if="record.content.fileext === 'xlsx' || record.content.fileext === 'xls' || record.content.fileext === 'csv'"
                  src="../assets/images/icon-xlsx.png"
                  width="40"
                />
                <img
                  v-else-if="record.content.fileext === 'txt'"
                  src="../assets/images/icon-txt.png"
                  width="40"
                />
                <img
                  v-else-if="record.content.fileext === 'zip'|| record.content.fileext === 'rar'"
                  src="../assets/images/icon-zip.png"
                  width="40"
                />
                <img
                  v-else-if="record.content.fileext === 'exe'"
                  src="../assets/images/icon-psd.png"
                  width="40"
                />
                <img
                  v-else-if="record.content.fileext === 'mp4' || record.content.fileext === 'avi' || record.content.fileext === 'm4a'"
                  src="../assets/images/icon-mp4.png"
                  width="40"
                />
                <img
                  v-else-if="record.content.fileext === 'mp3'"
                  src="../assets/images/icon-mp3.png"
                  width="40"
                />
                <img
                  v-else-if="record.content.fileext === 'pptx' || record.content.fileext === 'ppt'"
                  src="../assets/images/icon-ppt.png"
                  width="40"
                />
                <img
                  v-else-if="record.content.fileext === 'jpg' || record.content.fileext === 'png' || record.content.fileext === 'jpeg' || record.content.fileext === 'gif'"
                  src="../assets/images/icon-jpg.png"
                  width="40"
                />
                <img v-else src="../assets/images/icon-other.png" width="40" />
              </div>
              <div class="file-name">
                <div class="fgsdf" v-if="antistop" v-html="strMark(record.content.filename, antistop)"></div>
                <div class="fgsdf" v-else>{{record.content.filename}}</div>
                <div class="hioh">
                  {{ record.content.filesize }}
                </div>
              </div>
              </div>
          </div>
          <!-- 图片 -->
          <div v-else-if="record.type === 'ChatRecordImage' || record.type === 'ChatRecordEmotion'">
              <el-image
                v-if="record.content.url_path"
                style="width: 160px;"
                :src="record.content.url_path"
                :preview-src-list="srcList_image">
              </el-image>
              <el-image
                v-else
                style="width: 160px;"
                src="../assets/images/image.png">
              </el-image>
        </div>
          <!-- 混合消息 -->
          <div v-else-if="record.type === 'ChatRecordMixed'">
            <div v-for="(mixed, index) in record.content" :key="index">
              <div v-if="mixed.type === 'text' && antistop" v-html="strMark(JSON.parse(mixed.content).content, antistop)"></div>
              <div v-else-if="mixed.type === 'text'">{{JSON.parse(mixed.content).content}}</div>
              <div  v-else-if="mixed.type === 'emotion' || mixed.type === 'image'">
              <el-image
                v-if="mixed.content.url_path"
                style="width: 160px;"
                :src="mixed.content.url_path"
                :preview-src-list="srcList_image">
              </el-image>
              <el-image
                v-else
                style="width: 160px;"
                src="../assets/images/image.png">
              </el-image>
            </div>
            </div>
          </div>
          <!-- 视频 -->
          <div v-else-if="record.type === 'ChatRecordVideo'">
              <video :src="record.content.url_path" controls width="290px"></video>
          </div>
          <!-- 视频号 -->
          <ul v-else-if="record.type === 'ChatRecordSphFeed'">
            <div class="vios">
              <div class="vbi">
                <div class="bu">
                  <img class="img" src="../assets/images/shipin.png" width="40" height="40"/>
                </div>
                <div>
                  <div class="title" v-if="antistop" v-html="strMark(JSON.parse(record.content).sph_name, antistop)"></div>
                  <div class="title" v-else>{{JSON.parse(record.content).sph_name}}</div>
                  <div class="desc">{{ JSON.parse(record.content).feed_desc }}</div>
                </div>
              </div>
            </div>
          </ul>
          <!-- 链接 -->
          <ul class="link" v-if="record.type === 'ChatRecordLink'" @click="goLink(JSON.parse(record.content).link_url)">
            <div style="display: flex;">
              <div class="link-desc">
                <img
                v-if="JSON.parse(record.content).image_url !== ''"
                class="odns"
                :src="JSON.parse(record.content).image_url"
                width="40" />
                <img v-else src="../assets/images/link.png" width="40" />
              </div>
              <div class="info-title">
                <div class="dqww">
                  <span v-if="antistop" v-html="strMark(JSON.parse(record.content).title, antistop)"></span>
                  <span v-else>{{JSON.parse(record.content).title}}</span>
                </div>
                <div class="link-content">
                  <div class="fhih">{{ JSON.parse(record.content).description }}</div>
                </div>
              </div>
            </div>
          </ul>
          <!-- 位置 -->
          <div class="info-card location" v-else-if="record.type === 'ChatRecordLocation'">
            <div class="location-text ellipsis">
              <img src="../../src/assets/images/map_bg.png" width="304px" height="156px">
              <img class="euio" src="../../src/assets/images/ditu1.png" >
              <div class="address">
                <div class="zi">
                  <span>{{JSON.parse(record.content).title}}</span>
                </div>
                <div class="title">{{ JSON.parse(record.content).address }}</div>
              </div>
            </div>
          </div>
          <!-- 聊天记录 -->
          <ul
            class="info-card chatrecord"
            v-else-if="record.type === 'chatrecord'"
            @click="twoChatrecord(record.content)"
          >
            <div class="toa" v-if="antistop" v-html="strMark(JSON.parse(record.content).title, antistop)">的聊天记录</div>
            <div class="toa" v-else>{{JSON.parse(record.content).title}}的聊天记录</div>
            <div class="hufbdj" v-for="(item, index) in JSON.parse(record.content).item.slice(0, 3)" :key="index">
              <template v-if="item.type === 'ChatRecordText'">
                <span v-if="antistop" v-html="strMark(JSON.parse(item.content).content, antistop)"></span>
                <span v-else>{{JSON.parse(item.content).content}}</span>
              </template>
              <template v-if="item.type === 'ChatRecordImage'">
                [图片]
              </template>
              <template v-if="item.type === 'ChatRecordVideo'">
                [视频]
              </template>
              <template v-if="item.type === 'ChatRecordSphFeed'">
                [视频号]
              </template>
              <template v-if="item.type === 'ChatRecordLocation'">
                [位置]
              </template>
              <template v-if="item.type === 'ChatRecordWeapp'">
                [小程序]
              </template>
              <template v-if="item.type === 'ChatRecordVote'">
                [投票]
              </template>
              <template v-if="item.type === 'ChatRecordRedpacket'">
                [红包]
              </template>
               <template v-if="item.type === 'ChatRecordExternal_redpacket'">
                [互通红包]
              </template>
              <template v-if="item.type === 'chatrecord'">
                [聊天记录]
              </template>
              <template v-if="item.type === 'ChatRecordLink'">
                [链接]<span v-if="antistop" v-html="strMark(JSON.parse(item.content).title, antistop)"></span>
                <span v-else>{{JSON.parse(item.content).title}}</span>
              </template>
              <template v-if="item.type === 'ChatRecordFile'">
                [<span v-if="antistop" v-html="strMark(JSON.parse(item.content).filename, antistop)"></span><span v-else>{{JSON.parse(item.content).filename}}</span>]
              </template>
              <template v-if="item.type === 'ChatRecordMixed'">
                  <span v-for="(k, index) in JSON.parse(item.content).item" :key="index">
                    <span v-if="k.type === 'text'"><span v-if="antistop" v-html="strMark(JSON.parse(k.content).content, antistop)"></span>
                    <span v-else>{{JSON.parse(k.content).content}}</span></span>
                    <span v-else-if="k.type === 'image'">[图片]</span>
                    <span v-else-if="k.type === 'emotion'">[自定义表情]</span>
                  </span>
              </template>
            </div>
          </ul>
        </li>
      </ul>

      <!-- 2转发聊天记录 -->
      <el-dialog
      :title="title.length > 25 ? title.slice(0, 29) + '...' : title + '的聊天记录'"
      :modal-append-to-body="false"
      :visible.sync="secondRecord"
       width="557px"
       append-to-body
       @close="second">
        <ul class="chatrecord-list">
          <li class="info-title01"></li>
          <li v-for="(record, index) in chatrecordTwo" :key="index">
            <div style="color: rgba(0,0,0,0.2500);">
              {{ $moment(Number(record.msgtime + '000')).format('YYYY-MM-DD HH:mm:ss') }}
            </div>
             <!-- 文本 -->
            <div class="text" v-if="record.type === 'ChatRecordText'">
              <span v-if="antistop" v-html="strMark(JSON.parse(record.content).content, antistop)"></span>
              <span v-else-if="associat" v-html="strMarks(JSON.parse(record.content).content, associat)"></span>
              <span v-else>{{JSON.parse(record.content).content}}</span>
            </div>
            <!-- 文件 -->
            <div class="file" v-else-if="record.type === 'ChatRecordFile'" @click="download01(record)">
              <div style="display: flex;">
                <div class="ijdfj">
                  <img
                    v-if="JSON.parse(record.content).fileext === 'xmind'"
                    src="../assets/images/icon-psd.png"
                    width="40"
                  />
                  <img
                    v-else-if="JSON.parse(record.content).fileext === 'pdf'"
                    src="../assets/images/icon-pdf.png"
                    width="40"
                  />
                  <img
                    v-else-if="JSON.parse(record.content).fileext === 'doc' || JSON.parse(record.content).fileext ==='docx'"
                    src="../assets/images/icon-docx.png"
                    width="40"
                  />
                  <img
                    v-else-if="JSON.parse(record.content).fileext === 'xlsx' || JSON.parse(record.content).fileext === 'xls' || JSON.parse(record.content).fileext === 'csv'"
                    src="../assets/images/icon-xlsx.png"
                    width="40"
                  />
                  <img
                    v-else-if="JSON.parse(record.content).fileext === 'txt'"
                    src="../assets/images/icon-txt.png"
                    width="40"
                  />
                  <img
                    v-else-if="JSON.parse(record.content).fileext === 'zip'|| JSON.parse(record.content).fileext === 'rar'"
                    src="../assets/images/icon-zip.png"
                    width="40"
                  />
                  <img
                    v-else-if="JSON.parse(record.content).fileext === 'exe'"
                    src="../assets/images/icon-psd.png"
                    width="40"
                  />
                  <img
                    v-else-if="JSON.parse(record.content).fileext === 'mp4' || JSON.parse(record.content).fileext === 'avi' || JSON.parse(record.content).fileext === 'm4a'"
                    src="../assets/images/icon-mp4.png"
                    width="40"
                  />
                  <img
                    v-else-if="JSON.parse(record.content).fileext === 'mp3'"
                    src="../assets/images/icon-mp3.png"
                    width="40"
                  />
                  <img
                    v-else-if="JSON.parse(record.content).fileext === 'pptx' || JSON.parse(record.content).fileext === 'ppt'"
                    src="../assets/images/icon-ppt.png"
                    width="40"
                  />
                  <img
                    v-else-if="JSON.parse(record.content).fileext === 'jpg' || JSON.parse(record.content).fileext === 'png' || JSON.parse(record.content).fileext === 'jpeg' || record.content.fileext === 'gif'"
                    src="../assets/images/icon-jpg.png"
                    width="40"
                  />
                  <img v-else src="../assets/images/icon-other.png" width="40" />
                </div>
                <div class="file-name">
                  <div class="fgsdf" v-if="antistop" v-html="strMark(JSON.parse(record.content).filename, antistop)"></div>
                  <div class="fgsdf" v-else>{{JSON.parse(record.content).filename}}</div>
                  <div class="hioh">
                    {{ JSON.parse(record.content).filesize }}
                  </div>
                </div>
                </div>
            </div>
            <!-- 混合消息 -->
            <div v-else-if="record.type === 'ChatRecordMixed'">
              <div v-for="(mixed, index) in record.content" :key="index">
                <div v-if="mixed.type === 'text'">
                  <span v-if="antistop" v-html="strMark(JSON.parse(mixed.content).content, antistop)"></span>
                  <span v-else>{{JSON.parse(mixed.content).content}}</span>
                </div>
                <div  v-else-if="mixed.type === 'emotion' || mixed.type === 'image'">
                  <el-image
                    v-if="mixed.content.url_path"
                    style="width: 160px;"
                    :src="mixed.content.url_path"
                    :preview-src-list="srcList_image">
                  </el-image>
                  <el-image
                    v-else
                    style="width: 160px;"
                    src="../assets/images/image.png">
                  </el-image>
              </div>
              </div>
            </div>
            <!-- 视频 -->
            <div v-else-if="record.type === 'ChatRecordVideo'">
              <video :src="record.url_path" controls width="290px"></video>
            </div>
            <!-- 视频号 -->
            <ul v-else-if="record.type === 'ChatRecordSphFeed'">
              <div class="vios">
                <div class="vbi">
                  <div class="bu">
                    <img class="img" src="../assets/images/shipin.png" width="40" height="40"/>
                  </div>
                  <div>
                    <div class="title">
                      <span v-if="antistop" v-html="strMark(JSON.parse(record.content).sph_name, antistop)"></span>
                      <span v-else>{{JSON.parse(record.content).sph_name}}</span>
                    </div>
                    <div class="desc">{{ JSON.parse(record.content).feed_desc }}</div>
                  </div>
                </div>
              </div>
            </ul>
            <!-- 链接 -->
          <div class="link" v-if="record.type === 'ChatRecordLink'" @click="goLink(JSON.parse(record.content).link_url)">
            <div style="display: flex;">
              <div class="link-desc">
                <img
                v-if="JSON.parse(record.content).image_url !== ''"
                class="odns"
                :src="JSON.parse(record.content).image_url"
                width="40" />
                <img v-else src="../assets/images/link.png" width="40" />
              </div>
              <div class="info-title">
                <div class="dqww">
                  <span v-if="antistop" v-html="strMark(JSON.parse(record.content).title, antistop)"></span>
                  <span v-else>{{JSON.parse(record.content).title}}</span>
                </div>
                <div class="link-content">
                  <div class="fhih">{{ JSON.parse(record.content).description }}</div>
                </div>
              </div>
            </div>
          </div>
          <!-- 位置 -->
            <div class="info-card location" v-else-if="record.type === 'ChatRecordLocation'">
            <div class="location-text ellipsis">
              <img src="../../src/assets/images/map_bg.png" width="304px" height="156px">
              <img class="euio" src="../../src/assets/images/ditu1.png" >
              <div class="address">
                <div class="zi">
                  <span>{{JSON.parse(record.content).title}}</span>
                </div>
                <div class="title">{{ JSON.parse(record.content).address }}</div>
              </div>
            </div>
          </div>
          <!-- 聊天记录 -->
          <ul
            class="info-card chatrecord"
            v-else-if="record.type === 'chatrecord'"
            @click="threeChatrecord(record.content)"
          >
            <div class="toa" v-if="antistop" v-html="strMark(JSON.parse(record.content).title, antistop)">的聊天记录</div>
            <div class="toa" v-else>{{JSON.parse(record.content).title}}的聊天记录</div>
            <div class="hufbdj" v-for="(item, index) in JSON.parse(record.content).item" :key="index">
            <div v-show="index < 3">
              <template v-if="item.type === 'ChatRecordText'">
                <span v-if="antistop" v-html="strMark(JSON.parse(item.content).content, antistop)"></span>
                <span v-else>{{JSON.parse(item.content).content}}</span>
              </template>
              <template v-if="item.type === 'ChatRecordImage'">
                [图片]
              </template>
              <template v-if="item.type === 'ChatRecordVideo'">
                [视频]
              </template>
              <template v-if="item.type === 'ChatRecordSphFeed'">
                [视频号]
              </template>
              <template v-if="item.type === 'ChatRecordLocation'">
                [位置]
              </template>
              <template v-if="item.type === 'ChatRecordWeapp'">
                [小程序]
              </template>
              <template v-if="item.type === 'ChatRecordVote'">
                [投票]
              </template>
              <template v-if="item.type === 'ChatRecordRedpacket'">
                [红包]
              </template>
               <template v-if="item.type === 'ChatRecordExternal_redpacket'">
                [互通红包]
              </template>
              <template v-if="item.type === 'chatrecord'">
                [聊天记录]
              </template>
              <template v-if="item.type === 'ChatRecordLink'">
                [链接]<span v-if="antistop" v-html="strMark(JSON.parse(item.content).title, antistop)"></span>
                <span v-else>{{JSON.parse(item.content).title}}</span>
              </template>
              <template v-if="item.type === 'ChatRecordFile'">
                [<span v-if="antistop" v-html="strMark(JSON.parse(item.content).filename, antistop)"></span><span v-else>{{JSON.parse(item.content).filename}}</span>]
              </template>
              <template v-if="item.type === 'ChatRecordMixed'">
                  <span v-for="(k, index) in JSON.parse(item.content).item" :key="index">
                    <span v-if="k.type === 'text'"><span v-if="antistop" v-html="strMark(JSON.parse(k.content).content, antistop)"></span>
                    <span v-else>{{JSON.parse(k.content).content}}</span></span>
                    <span v-else-if="k.type === 'image'">[图片]</span>
                    <span v-else-if="k.type === 'emotion'">[自定义表情]</span>
                  </span>
              </template>
              </div>
            </div>
          </ul>
          <!-- 图片 -->
          <div v-else-if="record.type === 'ChatRecordImage' || record.type === 'ChatRecordEmotion'">
            <el-image
              v-if="record.content.url_path"
              style="width: 160px;"
              :src="record.content.url_path"
              :preview-src-list="srcList_image">
            </el-image>
            <el-image
              v-else
              style="width: 160px;"
              src="../assets/images/image.png">
            </el-image>
          </div>
          </li>
        </ul>

        <!-- 3转发聊天记录 -->
        <el-dialog
        :title="thirdTitle.length > 25 ? thirdTitle.slice(0, 29) + '...' : thirdTitle + '的聊天记录'"
        :modal-append-to-body="false"
        :visible.sync="thirdRecord"
        width="557px"
        append-to-body
        @close="third">
          <ul class="chatrecord-list">
            <li class="info-title01"></li>
            <li v-for="(record, index) in chatrecordThree" :key="index">
              <div style="color: rgba(0,0,0,0.2500);">
                {{ $moment(Number(record.msgtime + '000')).format('YYYY-MM-DD HH:mm:ss') }}
              </div>
               <!-- 文本 -->
              <div class="text" v-if="record.type === 'ChatRecordText'">
                <span v-if="antistop" v-html="strMark(JSON.parse(record.content).content, antistop)"></span>
                <span v-else-if="associat" v-html="strMarks(JSON.parse(record.content).content, associat)"></span>
                <span v-else>{{JSON.parse(record.content).content}}</span>
              </div>
              <!-- 文件 -->
            <div class="file" v-else-if="record.type === 'ChatRecordFile'" @click="download01(record)">
              <div style="display: flex;">
                <div class="ijdfj">
                  <img
                    v-if="JSON.parse(record.content).fileext === 'xmind'"
                    src="../assets/images/icon-psd.png"
                    width="40"
                  />
                  <img
                    v-else-if="JSON.parse(record.content).fileext === 'pdf'"
                    src="../assets/images/icon-pdf.png"
                    width="40"
                  />
                  <img
                    v-else-if="JSON.parse(record.content).fileext === 'doc' || JSON.parse(record.content).fileext ==='docx'"
                    src="../assets/images/icon-docx.png"
                    width="40"
                  />
                  <img
                    v-else-if="JSON.parse(record.content).fileext === 'xlsx' || JSON.parse(record.content).fileext === 'xls' || JSON.parse(record.content).fileext === 'csv'"
                    src="../assets/images/icon-xlsx.png"
                    width="40"
                  />
                  <img
                    v-else-if="JSON.parse(record.content).fileext === 'txt'"
                    src="../assets/images/icon-txt.png"
                    width="40"
                  />
                  <img
                    v-else-if="JSON.parse(record.content).fileext === 'zip'|| JSON.parse(record.content).fileext === 'rar'"
                    src="../assets/images/icon-zip.png"
                    width="40"
                  />
                  <img
                    v-else-if="JSON.parse(record.content).fileext === 'exe'"
                    src="../assets/images/icon-psd.png"
                    width="40"
                  />
                  <img
                    v-else-if="JSON.parse(record.content).fileext === 'mp4' || JSON.parse(record.content).fileext === 'avi' || JSON.parse(record.content).fileext === 'm4a'"
                    src="../assets/images/icon-mp4.png"
                    width="40"
                  />
                  <img
                    v-else-if="JSON.parse(record.content).fileext === 'mp3'"
                    src="../assets/images/icon-mp3.png"
                    width="40"
                  />
                  <img
                    v-else-if="JSON.parse(record.content).fileext === 'pptx' || JSON.parse(record.content).fileext === 'ppt'"
                    src="../assets/images/icon-ppt.png"
                    width="40"
                  />
                  <img
                    v-else-if="JSON.parse(record.content).fileext === 'jpg' || JSON.parse(record.content).fileext === 'png' || JSON.parse(record.content).fileext === 'jpeg' || record.content.fileext === 'gif'"
                    src="../assets/images/icon-jpg.png"
                    width="40"
                  />
                  <img v-else src="../assets/images/icon-other.png" width="40" />
                </div>
                <div class="file-name">
                  <div class="fgsdf" v-if="antistop" v-html="strMark(JSON.parse(record.content).filename, antistop)"></div>
                  <div class="fgsdf" v-else>{{JSON.parse(record.content).filename}}</div>
                  <div class="hioh">
                    {{ JSON.parse(record.content).filesize }}
                  </div>
                </div>
                </div>
            </div>
              <!-- 混合消息 -->
              <div v-else-if="record.type === 'ChatRecordMixed'">
                <div v-for="(mixed, index) in record.content" :key="index">
                  <div v-if="mixed.type === 'text'">
                    <span v-if="antistop" v-html="strMark(JSON.parse(mixed.content).content, antistop)"></span>
                    <span v-else>{{JSON.parse(mixed.content).content}}</span>
                  </div>
                  <div  v-else-if="mixed.type === 'emotion' || mixed.type === 'image'">
                      <el-image
                        v-if="mixed.content.url_path"
                        style="width: 160px;"
                        :src="mixed.content.url_path"
                        :preview-src-list="srcList_image">
                      </el-image>
                      <el-image
                        v-else
                        style="width: 160px;"
                        src="../assets/images/image.png">
                      </el-image>
                  </div>
                </div>
              </div>
              <!-- 视频 -->
              <div v-else-if="record.type === 'ChatRecordVideo'">
                <video :src="record.url_path" controls width="290px"> </video>
              </div>
              <!-- 链接 -->
              <ul class="link" v-if="record.type === 'ChatRecordLink'" @click="goLink(JSON.parse(record.content).link_url)">
                <div style="display: flex;">
                  <div class="link-desc">
                    <img
                    v-if="JSON.parse(record.content).image_url !== ''"
                    class="odns"
                    :src="JSON.parse(record.content).image_url"
                    width="40" />
                    <img v-else src="../assets/images/link.png" width="40" />
                  </div>
                  <div class="info-title">
                    <div class="dqww">
                      <span v-if="antistop"  v-html="strMark(JSON.parse(record.content).title, antistop)"></span>
                      <span v-else>{{JSON.parse(record.content).title}}</span>
                    </div>
                    <div class="link-content">
                      <div class="fhih">{{ JSON.parse(record.content).description }}</div>
                    </div>
                  </div>
                </div>
              </ul>
              <!-- 位置 -->
              <div class="info-card location" v-else-if="record.type === 'ChatRecordLocation'">
                <div class="location-text ellipsis">
                  <img src="../../src/assets/images/map_bg.png" width="304px" height="156px">
                  <img class="euio" src="../../src/assets/images/ditu1.png" >
                  <div class="address">
                    <div class="zi">
                     <span>{{JSON.parse(record.content).title}}</span>
                    </div>
                    <div class="title">{{ JSON.parse(record.content).address }}</div>

                  <!--  {{ item.content.longitude }} -->
                  </div>
                </div>
              </div>
              <!-- 视频号 -->
              <ul v-else-if="record.type === 'ChatRecordSphFeed'">
                <div class="vios">
                  <div class="vbi">
                    <div class="bu">
                      <img class="img" src="../assets/images/shipin.png" width="40" height="40"/>
                    </div>
                    <div>
                      <div class="title">
                        <span v-if="antistop" v-html="strMark(JSON.parse(record.content).sph_name, antistop)"></span>
                        <span v-else>{{JSON.parse(record.content).sph_name}}</span>
                      </div>
                      <div class="desc">{{ JSON.parse(record.content).feed_desc }}</div>
                    </div>
                  </div>
                </div>
              </ul>
              <!-- 聊天记录 -->
              <ul class="info-card" v-else-if="record.type === 'chatrecord'">
                <div>{{ JSON.parse(record.content).title || '--' }}</div>
                <div>暂不支持此消息类型</div>
              </ul>
              <!-- 图片 -->
              <div v-else-if="record.type === 'ChatRecordImage' || record.type === 'ChatRecordEmotion'">
                <el-image
                  v-if="record.content.url_path"
                  style="width: 160px;"
                  :src="record.content.url_path"
                  :preview-src-list="srcList_image">
                </el-image>
                <el-image
                  v-else
                  style="width: 160px;"
                  src="../assets/images/image.png">
                </el-image>
            </div>
            </li>
          </ul>
          <!-- <span slot="footer" class="dialog-footer">
            <el-button plain @click="thirdRecord = false">关 闭</el-button>
          </span> -->
        </el-dialog>

        <!--<span slot="footer" class="dialog-footer">
          <el-button plain @click="secondRecord = false">关 闭</el-button>
        </span>-->
      </el-dialog>

      <!-- <span slot="footer" class="dialog-footer">
        <el-button plain @click="$emit('close')">关 闭</el-button>
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
import { FILEURL, MSGTYPE, FILETYPE } from '@/config/constant'
 // const recordTypes = ['ChatRecordVideo', 'ChatRecordImage', 'ChatRecordFile']

export default {
  props: {
    chatrecord: {
      type: Object,
      required: true
    },
    visible: {
      type: Boolean,
      required: true,
      value: false
    },
    antistop: {
      type: String
    },
    associat: {
      type: String
    },
    srcList_image: {
      type: Array
    }
  },
  data() {
    return {
      FILEURL,
      userList: [],
      secondRecord: false,
      thirdRecord: false,
      chatrecordTwo: [],
      chatrecordThree: [],
      fileType: FILETYPE,
      msgType: MSGTYPE,
      title: '',
      thirdTitle: ''
    }
  },
  watch: {
    msgId: function(newVal, oldVal) {
      this.dialog = []
      this.page = 1
      this.upPage = 1
    },
    chatrecordTwo: function(content) {
      // this.twoChatrecord()
    }
  },
  mounted() {
    this.getTitle()
  },
  methods: {
    getTitle() {
      console.log(this.chatrecord.content)
    },
    strMarks(str, marks) {
      let chars = []
      chars = marks.split(',')
      chars.forEach(k => {
        str = str.toString().replaceAll(k, '<span style="color: red;">' + k + '</span>')
      })
      return str
    },
    strMark(str, mark) {
      if (!mark) {
        return false
      } else {
        let chars = []
        if (/^[a-zA-Z]*$/.test(str)) {
          var y = str.toLowerCase()
          chars = mark.split(',')
          chars.forEach(k => {
            y = y.replace(k, '<span style="background: #FAFF85FF;">' + k + '</span>')
          })
          return y
        } else {
          chars = mark.split(',')
          chars.forEach(k => {
            str = str.toString().replace(k, '<span style="background: #FAFF85FF;">' + k + '</span>')
          })
          return str
        }
      }
    },
    cardname(val) {
      this.$api
        .get('/user/search-staff', {
          type: 1,
          user_id: val
        })
        .then(res => {})
    },
    twoChatrecord(content) {
      this.secondRecord = true
      this.title = JSON.parse(content).title
      try {
        this.chatrecordTwo = []
        const chatRecord = JSON.parse(content).item
        chatRecord.forEach(async v => {
          if (v.type === 'ChatRecordFile') {
            if (typeof v.content === 'string') {
              const md5 = JSON.parse(v.content).md5sum
              if (md5) {
                const res = await this.getFile(md5)
                if (!res.path.includes('http')) {
                  v.url_path = FILEURL + res.path
                } else {
                  v.url_path = res.path
                }
              }
            }
          }
          if (v.type === 'ChatRecordImage') {
            console.log('zzzzzzzzzzzz', this.srcList_image)
            if (typeof v.content === 'string') {
              const md5 = JSON.parse(v.content).md5sum
              if (md5) {
                const res = await this.getFile(md5)
                if (!res.path.includes('http')) {
                  v.content = {
                    url_path: FILEURL + res.path
                  }
                } else {
                  v.content = {
                    url_path: res.path
                  }
                }
                this.srcList_image.push(v.content.url_path)
              }
            }
          }
          if (v.type === 'ChatRecordVideo') {
            if (typeof v.content === 'string') {
              const md5 = JSON.parse(v.content).md5sum
              if (md5) {
                const res = await this.getFile(md5)
                if (!res.path.includes('http')) {
                  v.url_path = FILEURL + res.path
                } else {
                  v.url_path = res.path
                }
              }
            }
          }
          if (v.type === 'ChatRecordMixed') {
              if (typeof v.content === 'string') {
                const arr = JSON.parse(v.content).item
                arr.forEach(async k => {
                  if (k.type === 'image' || k.type === 'emotion') {
                    const md5 = JSON.parse(k.content).md5sum
                    if (md5 || md5 !== '') {
                      const res = await this.getFile(md5)
                      if (!res.path.includes('http')) {
                        k.content = {
                          url_path: FILEURL + res.path
                        }
                      } else {
                         k.content = {
                          url_path: res.path
                        }
                      }
                    }
                  }
                })
                v.content = arr
              }
            }
        })
        this.chatrecordTwo = chatRecord
      } catch (error) {
      }
    },
    async threeChatrecord(content) {
       this.thirdRecord = true
       this.thirdTitle = JSON.parse(content).title
      try {
        this.chatrecordThree = []
        const chatrecord = JSON.parse(content).item
        chatrecord.forEach(async v => {
          if (v.type === 'ChatRecordFile') {
            if (typeof v.content === 'string') {
              const md5 = JSON.parse(v.content).md5sum
              if (md5) {
                const res = await this.getFile(md5)
                if (!res.path.includes('http')) {
                  v.url_path = FILEURL + res.path
                } else {
                  v.url_path = res.path
                }
              }
            }
          }
          if (v.type === 'ChatRecordImage') {
            if (typeof v.content === 'string') {
              const md5 = JSON.parse(v.content).md5sum
              if (md5) {
                const res = await this.getFile(md5)
                if (!res.path.includes('http')) {
                  v.content = {
                    url_path: [FILEURL + res.path]
                  }
                } else {
                  v.content = {
                    url_path: [res.path]
                  }
                }
                this.srcList_image.push(v.content.url_path)
              }
            }
          }
          if (v.type === 'ChatRecordVideo') {
            if (typeof v.content === 'string') {
              const md5 = JSON.parse(v.content).md5sum
              if (md5) {
                const res = await this.getFile(md5)
                if (!res.path.includes('http')) {
                  v.url_path = FILEURL + res.path
                } else {
                  v.url_path = res.path
                }
              }
            }
          }
          if (v.type === 'ChatRecordMixed') {
              if (typeof v.content === 'string') {
                const arr = JSON.parse(v.content).item
                arr.forEach(async k => {
                  if (k.type === 'image' || k.type === 'emotion') {
                    const md5 = JSON.parse(k.content).md5sum
                    if (md5 || md5 !== '') {
                      const res = await this.getFile(md5)
                      if (!res.path.includes('http')) {
                        k.content = {
                          url_path: [FILEURL + res.path]
                        }
                      } else {
                         k.content = {
                          url_path: [res.path]
                        }
                      }
                    }
                    this.srcList_image.push(k.content.url_path)
                  }
                })
                v.content = arr
              }
            }
        })
        this.chatrecordThree = chatrecord || []
      } catch (error) {
      }
    },
    async getFile(md5sum) {
      try {
        const file = await this.$api.get('/api/system/get/file', {
          md5sum: md5sum
        })
        if (file) {
          return file
        } else {
          return ''
        }
      } catch (error) {
      }
    },
    download01(item, index) {
      if (item.content.url_path !== '' || item.url_path !== '') {
        const url = item.content.url_path || item.url_path
        if (url) {
          this.$confirm('是否下载该文件？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            showClose: false,
            type: 'warning',
            closeOnClickModal: false
          })
          .then(() => {
            if (url !== '') {
              if (url.includes('http')) {
                window.open(url)
              } else {
                window.open(FILEURL + url)
              }
            } else {
              this.$message.warning('数据正在同步中，请稍后重新进入查看')
            }
          })
        }
      } else {
        this.$message.warning('数据正在同步中，请稍后重新进入查看')
      }
    },
    download010(item) {
      if (item.url_path !== '') {
        const url = item.url_path
        if (url) {
          this.$confirm('是否下载该文件？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            showClose: false,
            type: 'warning',
            closeOnClickModal: false
          })
          .then(() => {
            if (url !== '') {
              if (url.includes('http')) {
                window.open(url)
              } else {
                window.open(FILEURL + url)
              }
            } else {
              this.$message.warning('数据正在同步中，请稍后重新进入查看')
            }
          })
        }
      } else {
        this.$message.warning('数据正在同步中，请稍后重新进入查看')
      }
    },
    download02(item) {
      if (item.url_path !== '') {
        window.open(item.url_path)
      } else {
        this.$message.warning('数据正在同步中，请稍后重新进入查看')
      }
    },
    download03(item) {
      if (item.url_path !== '') {
        window.open(item.url_path)
      } else {
        this.$message.warning('数据正在同步中，请稍后重新进入查看')
      }
    },
    goLink(url) {
      if (url.includes('https://work')) {
        return false
      } else {
        window.open(url)
      }
    },
    first() {
      this.$emit('close')
    },
    second() {
      this.secondRecord = false
    },
    third() {
      this.thirdRecord = false
    }
  }
}
</script>
<style lang="scss" scoped>
$dialog-bg: #f8f8f8;
.infinite-list {
  height: 100%;
  max-height: 664px;
  overflow-y: auto;
  overflow-x: hidden;

  .infinite-list-item {
    margin-bottom: 22px;
    line-height: 1.4em;
    .dialog-info {
      color: #909399;
      margin-bottom: 8px;

      .name {
        padding-right: 15px;
      }
    }
  }

}
.up-btn {
  float: right;
}
.chatrecord-list {
  text-align: left;
  max-height: 600px;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 24px;
  li {
    margin-bottom: 14px;
    border-bottom: 1px solid hsla(220, 20%, 91%, 1);

    & > div {
      margin-bottom: 10px;
    }
    .text {
      display:table;
      // padding: 12px;
      max-width: 500px;
      // box-shadow: 0px 2px 10px 0px rgba(2, 47, 50, 0.1);
      // border-radius: 4px;
      // border: 1px solid #e4e7ed;
      // background: #fff;
      margin-bottom: 10px;
    }
    .chatrecord{
      margin-bottom: 10px;
    }
    .location {
      height: 132px;
      width: 280px;
      background-size: 100% 100%;
      position: relative;
      margin-top: 20px;
      margin-bottom: 10px;
      .location-text {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        color: #fff;
        box-sizing: border-box;
        .euio{
          width:.75rem;
          height: 2rem;
          position: absolute;
          left: 118px;
          top: 22px;
        }
        .address{
          width:100%;
          height: 45px;
          position: absolute;
          left: 0;
          line-height: 25px;
          border-radius: 0 0 2px 2px;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5)
        }
      }
      .zi{
        width: 290px;
        padding: 0 .625rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .title{
        width:290px;
        padding: 0 .625rem;
        font-size: .45rem;
        line-height: 16px;
        color: hsla(0, 0%, 100%, 0.8);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .vios{
      width: 310px;
      height: 48px;
      padding: 8px;
      background: rgba(255, 255, 255, 0.39);
      margin-left: -40px;
      background: #ffffff;
      border-radius: 2px;
      box-shadow: 0px 2px 4px rgba(2, 47, 50, 0.08);
      margin-bottom: 10px;
      .vbi{
        display: flex;
        .bu{
          display: flex;
        }
        .title{
          width: 90%;
          padding: 0 12px;
          height: 16px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          line-height: 16px;
          color: rgba(0, 0, 0, 0.85);
          overflow:hidden;
          text-overflow:ellipsis;
          white-space:nowrap;
        }
        .desc{
          width: 246px;
          font-size: 12px;
          padding: 0 12px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          line-height: 40px;
          color: hsla(0, 0%, 0%, 0.25);
          overflow:hidden;
          text-overflow:ellipsis;
          white-space:nowrap;
        }
      }
    }
    .link {
      // display: flex;
      width: 310px;
      height: 48px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 2px 4px rgba(2, 47, 50, 0.08);
      border-radius: 2px;
      padding: 8px;
      margin-bottom: 10px;
      .link-desc {
        display: flex;
        color:hsla(0, 0%, 0%, 0.25);
        .odns{
          position: relative;
          top: 3px;
        }
        .link-text {
          flex: 1;
          overflow: hidden;
        }
      }
      .info-title {
        width: 100%;
        margin-left: 8px;
        .dqww{
          height: 25px;
          width: 85%;
          white-space:nowrap;
          overflow:hidden;
          text-overflow:ellipsis;;
          color: rgba(0, 0, 0, 0.85);
          font-size: 14px;
          color: rgba(0, 0, 0, 0.85);
        }
      }
      .link-content{
        display: flex;
        .fhih{
          width: 246px;
          white-space:nowrap;
          overflow:hidden;
          text-overflow:ellipsis;
          color: hsla(0, 0%, 0%, 0.25);
        }
      }
  }
  }
  .agree {
      display: table;
      padding: 2px 10px;
      color: #909399;
      background: $dialog-bg;

      border-radius: 10px;
      i {
        padding-right: 5px;
      }
      &.revoke {
        margin-top: 10px;
      }
    }
    .msg {
      margin: 0;
    }
  }

  .weapp {
    .weapp-title {
      display: flex;
      align-items: center;
      color: #909399;

      .icon-weapp {
        margin-right: 10px;
      }
    }

    .weapp-info {
      margin-top: 10px;
    }
  }
  .file {
    width: 310px;
    height: 48px;
    padding: 8px;
    box-shadow: 0px 2px 10px 0px rgba(2, 47, 50, 0.1);
    border-radius: 2px;
    background: #fff;
    .ijdfj{
      width: 50px;
    }
    .file-name {
      width: 240px;
      color: #303133;
      .fgsdf{
        width: 100%;
        height: auto;
        display: -webkit-box;
        overflow: hidden;
        /*! autoprefixer: off; */
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
      }
    }
    .hioh{
      margin-top: 18px;
      font-weight: 400;
      font-size: 12px;
      color: hsla(0, 0%, 0%, 0.45);
    }
    .icon-download{
      position: relative;
      left: 15px;
    }
    .icon01{
      position: relative;
      left: 35px;
      top: 18px;
      width: 14px;
    }
    img {
      margin-top: 3px;
    }
  }
.info-title01{
  text-align: center;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 28px;
  color: #204A9E;
  opacity: 1;
}
::v-deep .el-message-box__close{
  color: hsla(220, 66%, 37%, 1);
}
::v-deep .el-dialog__title{
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  margin-left: 0;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  opacity: 1;
}
.icon-dssad{
      position: relative;
      left: 35px;
  }
  ::v-deep .el-dialog__body{
    background: #FFFFFF;
    padding: 0;
  }
  .toa{
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    margin-bottom: 12px;
    line-height: 24px;
    color: rgba(0, 0, 0, 0.85);
    opacity: 1;
  }
  .hufbdj{
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.25);
    opacity: 1;
  }
  ::v-deep .el-icon-close:before{
    font-size: 16px;
  }
  ::v-deep .el-dialog__title::before {
    display: none;
  }
</style>
